var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.75C12.09 22.75 11.75 22.41 11.75 22V20C11.75 19.59 12.09 19.25 12.5 19.25C12.91 19.25 13.25 19.59 13.25 20V22C13.25 22.41 12.91 22.75 12.5 22.75Z",
    fill: "#080808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.75C12.09 18.75 11.75 18.41 11.75 18V16C11.75 15.59 12.09 15.25 12.5 15.25C12.91 15.25 13.25 15.59 13.25 16V18C13.25 18.41 12.91 18.75 12.5 18.75Z",
    fill: "#080808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.75C12.09 14.75 11.75 14.41 11.75 14V11C11.75 6.73 15.23 3.25 19.5 3.25H22.5C22.91 3.25 23.25 3.59 23.25 4C23.25 4.41 22.91 4.75 22.5 4.75H19.5C16.05 4.75 13.25 7.55 13.25 11V14C13.25 14.41 12.91 14.75 12.5 14.75Z",
    fill: "#080808"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.75C12.09 14.75 11.75 14.41 11.75 14V11C11.75 7.55 8.95 4.75 5.5 4.75H2.5C2.09 4.75 1.75 4.41 1.75 4C1.75 3.59 2.09 3.25 2.5 3.25H5.5C9.77 3.25 13.25 6.73 13.25 11V14C13.25 14.41 12.91 14.75 12.5 14.75Z",
    fill: "#080808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75C4.31 6.75 4.12 6.68 3.97 6.53L1.97 4.53C1.68 4.24 1.68 3.76 1.97 3.47L3.97 1.47C4.26 1.18 4.74 1.18 5.03 1.47C5.32 1.76 5.32 2.24 5.03 2.53L3.56 4L5.03 5.47C5.32 5.76 5.32 6.24 5.03 6.53C4.88 6.68 4.69 6.75 4.5 6.75Z",
    fill: "#080808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.75C20.31 6.75 20.12 6.68 19.97 6.53C19.68 6.24 19.68 5.76 19.97 5.47L21.44 4L19.97 2.53C19.68 2.24 19.68 1.76 19.97 1.47C20.26 1.18 20.74 1.18 21.03 1.47L23.03 3.47C23.32 3.76 23.32 4.24 23.03 4.53L21.03 6.53C20.88 6.68 20.69 6.75 20.5 6.75Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderArrow);
export default __webpack_public_path__ + "static/media/order-arrow.088cdf219facb8c35364885eb635a3f9.svg";
export { ForwardRef as ReactComponent };